import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const events = [
    {
      title: 'World War I',
      period: '1914 - 1918',
      description: 'The Great War that reshaped the modern world, claiming millions of lives and redrawing the map of Europe.',
      image: 'https://images.unsplash.com/photo-1574088768814-c71125083959?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHx3b3JsZCUyMHdhciUyMHRyZW5jaGVzfGVufDB8fHx8MTc3NjE1Nzk2MHww&ixlib=rb-4.1.0&q=85',
      path: '/wwi',
      testId: 'event-card-wwi'
    },
    {
      title: 'World War II',
      period: '1939 - 1945',
      description: 'The deadliest military conflict in history, a global war that changed the course of human civilization.',
      image: 'https://images.unsplash.com/photo-1573677394729-54f076176265?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHx3b3JsZCUyMHdhciUyMHR3b3xlbnwwfHx8fDE3NzYxNTgwMDJ8MA&ixlib=rb-4.1.0&q=85',
      path: '/wwii',
      testId: 'event-card-wwii'
    },
    {
      title: 'Napoleonic Wars',
      period: '1803 - 1815',
      description: 'A series of major conflicts that pitted the French Empire against various European coalitions.',
      image: 'https://cache.getarchive.net/Prod/thumb/cdn2/L3Bob3RvLzE4NTAvMTIvMzEvZnJhbmNvaXMtcGFzY2FsLXNpbW9uLWdlcmFyZC1sYS1iYXRhaWxsZS1kYXVzdGVybGl0ei0yLWRlY2VtYnJlLTE4MDUtNTNiYzIxLTEwMjQuanBn/320/143/jpg',
      path: '/napoleonic',
      testId: 'event-card-napoleonic'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div 
        className="relative h-screen bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1524661135-423995f22d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHx2aW50YWdlJTIwbWFwfGVufDB8fHx8MTc3NjE1NzkzNnww&ixlib=rb-4.1.0&q=85)'
        }}
        data-testid="hero-section"
      >
        <div className="hero-overlay absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white px-6">
            <h1 className="text-6xl md:text-8xl font-bold mb-6 text-amber-400" data-testid="hero-title">
              Events That Changed History
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-amber-100 max-w-3xl mx-auto leading-relaxed" data-testid="hero-subtitle">
              Explore the pivotal moments that shaped our world and defined the course of human civilization
            </p>
            <div className="section-divider max-w-md mx-auto"></div>
            <p className="text-lg text-amber-200 mt-8 italic">
              "Those who cannot remember the past are condemned to repeat it" - George Santayana
            </p>
          </div>
        </div>
      </div>

      {/* Events Section */}
      <div className="container mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-stone-800 mb-4" data-testid="events-section-title">
            Major Historical Conflicts
          </h2>
          <div className="section-divider max-w-xs mx-auto"></div>
          <p className="text-xl text-stone-600 mt-6 max-w-2xl mx-auto">
            Discover the wars and conflicts that fundamentally transformed the political, social, and cultural landscape of our world
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10 mt-12">
          {events.map((event, index) => (
            <Link 
              key={index}
              to={event.path}
              className="event-card group"
              data-testid={event.testId}
            >
              <div className="bg-white rounded-lg overflow-hidden shadow-xl historical-border">
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={event.image} 
                    alt={event.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-2xl font-bold text-white mb-1">{event.title}</h3>
                    <p className="text-amber-300 font-semibold text-lg">{event.period}</p>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-stone-700 text-lg leading-relaxed">
                    {event.description}
                  </p>
                  <div className="mt-6 flex items-center text-amber-600 font-semibold group-hover:text-amber-700">
                    <span>Explore Details</span>
                    <svg className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-amber-100 py-8 border-t border-amber-700">
        <div className="container mx-auto px-6 text-center">
          <p className="text-lg">
            © 2025 History Vault - Preserving the Past, Illuminating the Future
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;